<template>
  <div class="games">
    <div class="header">
      <StarIcon class="icon" />
      <h1 class="title">{{ i18n.playedRecently }}</h1>
    </div>
    <div class="contentWrapper">
      <div class="content">
        <div class="item"
             :key="game.tenantGameId"
             v-for="(game, index) in state.games"
             @click="selectGame(game)">
             <img class="thumb"
             v-if="game.thumbUrl"
             :src="failedThumbnails[index] ? fallbackThumbnail : game.thumbUrl"
             @error="handleImageError(index)"
             :alt="game.name" />
        <p v-if="failedThumbnails[index]"
           class="title">
          {{ game.displayName }}
        </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, inject, ref } from 'vue';
import StarIcon from './StarIcon';

export default {
  name: 'Games',
  components: { StarIcon },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const i18n = inject('i18n');
    const state = reactive({
      games: props.data,
    });
    const env = process.env.NODE_ENV === 'development' ? 'nsoftcasino-dev' : 'nsoftcasino';
    // Track which thumbnails failed to load
    const failedThumbnails = ref([]);
    const fallbackThumbnail = `https://storage.googleapis.com/${env}/resources/lobby/placeholder.png`;

    const selectGame = (game) => {
      window.parent.postMessage(
        {
          action: 'OpenGame',
          value: JSON.parse(JSON.stringify(game)),
        },
        '*',
      );
    };

    const handleImageError = (index) => {
      failedThumbnails.value[index] = true;
    };

    return {
      state,
      selectGame,
      i18n,
      failedThumbnails,
      fallbackThumbnail,
      handleImageError,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../style/scrollbar";

.games {
  padding-right: 30px;
  padding-left: 10px;

  .header {
    display: grid;
    justify-content: start;
    align-items: center;
    grid-template-columns: 26px auto;
    padding: 0 10px;
    padding-left: 0;

    .title {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
    }
  }

  .content {
    display: block;
    height: 100px;
    width: max-content;
    margin-bottom: 10px;
    padding: 10px 0;
  }

  .contentWrapper {
    display: block;
    width: 100%;
    height: inherit;
    overflow-x: auto;
    margin-bottom: 20px;
    @include scrollbar();
  }

  .item {
    display: grid;
    align-content: center;
    border-radius: 10px;
    position: relative;
    float: left;
    width: 142px;
    height: 230px;;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2);
    margin-right: 10px;
    box-shadow: 1px 20px 40px -28px #8b2f61;
    -webkit-box-shadow: 1px 20px 40px -28px #8b2f61;
    -moz-box-shadow: 1px 20px 40px -28px #8b2f61;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 12px;
      font-weight: 700;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .thumb {
    width: 100%;
    height: inherit;
    max-height: 100%;
    object-fit: cover;
    border-radius: inherit;
    font-size: 0;
    pointer-events: none;
  }
}
</style>
